import { LoadingWave } from '@/components/Charts/LoadingWave';

import { classNames } from '@/utils/classnames';

type TokenPriceChartLoadingProps = {
  height: number;
  /** Reserves the row below the chart (chart type, resolution, timeframes). */
  showBottomControls?: boolean;
  /** Reserves the row above the chart (metric buttons). */
  showTopControls?: boolean;
  /** The top row is taller when it also holds the token selector. */
  hasTopSelector?: boolean;
};

export const TokenPriceChartLoading = ({
  height,
  showBottomControls = false,
  showTopControls = false,
  hasTopSelector = false,
}: TokenPriceChartLoadingProps) => (
  <div
    className={classNames(
      'w-full',
      { 'pb-10.5': showBottomControls },
      { 'pt-7': showTopControls && !hasTopSelector },
      { 'pt-10.5': hasTopSelector },
    )}
  >
    <div className="w-full" style={{ height }}>
      <LoadingWave />
    </div>
    <span className="sr-only">Loading price chart</span>
  </div>
);
